import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroFullOverlayInnerContent',
})(({ typography: { pxToRem }, spacing, brandColors, type, breakpoints }) => ({
  onDark: {
    '& .primaryTextColor': {
      color: brandColors.white,
    },
    '& .accentTextColor': {
      color: brandColors.tintsOffWhite40,
    },
  },
  onLight: {
    '& .primaryTextColor': {
      color: brandColors.black,
    },
    '& .accentTextColor': {
      color: brandColors.tintsNeutral20,
    },
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  ctaContainer: {
    display: 'flex',
    // Buttons sit side by side and only wrap to a stacked layout when the
    // labels are too long to fit on a single row.
    flexWrap: 'wrap',
    columnGap: spacing(-1),
    rowGap: spacing(1),
  },
  centerItems: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  gapMinusOne: {
    gap: spacing(-1),
  },
  gapOne: {
    gap: spacing(1),
  },
  gapTwo: {
    gap: spacing(2),
  },
  bulletedList: {
    paddingLeft: pxToRem(35),
    textAlign: 'left',

    '& li': {
      '&:not(:last-child)': {
        marginBottom: spacing(-1),
      },
    },
  },
  termsAndConditionsText: {
    textDecoration: 'none',
  },

  // custom type setup for slide mode
  heading: {
    [breakpoints.up('xs')]: { ...type['40_medium'] },
    [breakpoints.up('lg')]: { ...type['64_medium'] },
  },
  subheading: {
    [breakpoints.up('xs')]: { ...type['18_regular'] },
    [breakpoints.up('lg')]: { ...type['24_regular'] },
  },
}));

export default useStyles;
